import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/imagen_nosotros_alfapack.png'
import _imports_1 from '../assets/Bebidas.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "block pb-6 pt-6" }
const _hoisted_3 = { class: "columns is-centered is-mobile" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6 pt-4 pb-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "has-ratio",
    src: _imports_0,
    alt: "imagen_nosotros_alfapack.png"
  })
], -1)
const _hoisted_7 = { class: "container pt-6 pb-6" }
const _hoisted_8 = { class: "columns is-centered is-mobile pb-6" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = { class: "columns is-mobile" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6 pt-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " ESTADO DE MÉXICO ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740 ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671 ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " contacto@alfapack.com.mx ", -1)
const _hoisted_17 = { class: "column" }
const _hoisted_18 = {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6 pt-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " MÉRIDA ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740 ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671 ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " contacto@alfapack.com.mx ", -1)
const _hoisted_23 = {
  class: "hero p-2",
  style: {"background-color":"#f4f4f6"}
}
const _hoisted_24 = { class: "container" }
const _hoisted_25 = { class: "block pt-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-primary has-text-centered has-text-weight-bold" }, [
  /*#__PURE__*/_createTextVNode(" Esto manejamos "),
  /*#__PURE__*/_createElementVNode("span", { class: "has-text-yellow" }, "contáctanos.")
], -1)
const _hoisted_27 = { class: "block pt-6" }
const _hoisted_28 = { class: "columns is-variable is-4" }
const _hoisted_29 = { class: "column" }
const _hoisted_30 = {
  class: "has-text-primary has-text-centered is-size-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Alimentos ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit ", -1)
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"column\"><p class=\"has-text-primary has-text-centered is-size-6 pb-0\" style=\"font-family:Calibri;font-weight:bold;\"><img src=\"" + _imports_1 + "\" alt=\"Bebidas.svg\" width=\"125\" height=\"125\"></p><p class=\"has-text-centered has-text-primary has-text-weight-bold\" style=\"font-family:Calibri;\"> Bebidas </p><p class=\"has-text-centered has-text-primary has-text-weight-bold\" style=\"font-family:Calibri;\"> Lorem ipsum dolor sit amet, consectetuer adipiscing elit </p></div>", 1)
const _hoisted_34 = { class: "column" }
const _hoisted_35 = {
  class: "has-text-primary has-text-centered is-size-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Pharma ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit ", -1)
const _hoisted_38 = { class: "column" }
const _hoisted_39 = {
  class: "has-text-primary has-text-centered is-size-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Automotriz ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit ", -1)
const _hoisted_42 = { class: "columns is-variable is-4" }
const _hoisted_43 = { class: "column" }
const _hoisted_44 = {
  class: "has-text-primary has-text-centered is-size-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Empaque y Embalaje ", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit ", -1)
const _hoisted_47 = { class: "column" }
const _hoisted_48 = {
  class: "has-text-primary has-text-centered is-size-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Nutracéutica ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit ", -1)
const _hoisted_51 = { class: "column" }
const _hoisted_52 = {
  class: "has-text-primary has-text-centered is-size-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lacteos ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit ", -1)
const _hoisted_55 = { class: "column" }
const _hoisted_56 = {
  class: "has-text-primary has-text-centered is-size-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Química ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-centered has-text-primary has-text-weight-bold",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit ", -1)

import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import DifferenceComponent from "@/components/DifferenceComponent.vue";
import ContactMedia from "@/components/ContactMedia.vue";
import { useWindowSize } from "vue-window-size";
import SvgIcon from "@jamescoyle/vue-icon";
import {
  mdiMapMarker,
  mdiFoodApple,
  mdiPill,
  mdiCar,
  mdiPackageVariantClosed,
  mdiFlaskRoundBottom,
  mdiLeaf,
  mdiCheese,
} from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const { width } = useWindowSize();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ContactBar),
      _createVNode(NavigationBar),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri","font-weight":"bold"}
        }, " NOSOTROS Y NUESTRA HISTORIA ", 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["column", _unref(width) < 768 ? 'is-four-fifths' : 'is-two-thirds'])
          }, _hoisted_5, 2)
        ])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(["column", _unref(width) < 768 ? 'is-four-fifths' : 'is-two-thirds'])
        }, [
          _createElementVNode("h1", {
            class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
            style: {"font-family":"Calibri","font-weight":"bold"}
          }, " ESTAMOS PRESENTES EN MÉXICO, CENTROAMÉRICA, EL CARIBE ", 2)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, [
              _createVNode(_unref(SvgIcon), {
                type: "mdi",
                class: "p-4",
                path: _unref(mdiMapMarker),
                style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%"}
              }, null, 8, ["path"])
            ]),
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", _hoisted_18, [
              _createVNode(_unref(SvgIcon), {
                type: "mdi",
                class: "p-4",
                path: _unref(mdiMapMarker),
                style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%"}
              }, null, 8, ["path"])
            ]),
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _hoisted_22
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("h1", {
            class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
            style: {"font-family":"Calibri","font-weight":"bold"}
          }, " INDUSTRIAS ", 2),
          _hoisted_26
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", _hoisted_30, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-4",
                  type: "mdi",
                  path: _unref(mdiFoodApple),
                  style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%","padding":"0.75rem"}
                }, null, 8, ["path"])
              ]),
              _hoisted_31,
              _hoisted_32
            ]),
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("p", _hoisted_35, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-4",
                  type: "mdi",
                  path: _unref(mdiPill),
                  style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%","padding":"0.75rem"}
                }, null, 8, ["path"])
              ]),
              _hoisted_36,
              _hoisted_37
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("p", _hoisted_39, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-4",
                  type: "mdi",
                  path: _unref(mdiCar),
                  style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%","padding":"0.75rem"}
                }, null, 8, ["path"])
              ]),
              _hoisted_40,
              _hoisted_41
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["block pb-6", _unref(width) < 768 ? '' : 'pt-6'])
        }, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("p", _hoisted_44, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-4",
                  type: "mdi",
                  path: _unref(mdiPackageVariantClosed),
                  style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%","padding":"0.75rem"}
                }, null, 8, ["path"])
              ]),
              _hoisted_45,
              _hoisted_46
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("p", _hoisted_48, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-4",
                  type: "mdi",
                  path: _unref(mdiLeaf),
                  style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%","padding":"0.75rem"}
                }, null, 8, ["path"])
              ]),
              _hoisted_49,
              _hoisted_50
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("p", _hoisted_52, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-4",
                  type: "mdi",
                  path: _unref(mdiCheese),
                  style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%","padding":"0.75rem"}
                }, null, 8, ["path"])
              ]),
              _hoisted_53,
              _hoisted_54
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("p", _hoisted_56, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-4",
                  type: "mdi",
                  path: _unref(mdiFlaskRoundBottom),
                  style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%","padding":"0.75rem"}
                }, null, 8, ["path"])
              ]),
              _hoisted_57,
              _hoisted_58
            ])
          ])
        ], 2)
      ])
    ]),
    _createVNode(DifferenceComponent),
    _createVNode(ContactMedia),
    _createVNode(FooterComponent)
  ], 64))
}
}

})